import {
    GET_SESSIONS,
    GET_SESSIONS_FAIL,
    GET_SESSIONS_SUCCESS,
    ADD_NEW_SESSION,
    ADD_SESSION_SUCCESS,
    ADD_SESSION_FAIL,
    UPDATE_SESSION,
    UPDATE_SESSION_SUCCESS,
    UPDATE_SESSION_FAIL,
    DELETE_SESSION,
    DELETE_SESSION_SUCCESS,
    DELETE_SESSION_FAIL,

    GET_SESSION_RESULTS,          // 
    GET_SESSION_RESULTS_SUCCESS,  // 
    GET_SESSION_RESULTS_FAIL,     // 

    PROCLAMER_SESSION,
    PROCLAMER_SESSION_SUCCESS,
    PROCLAMER_SESSION_FAIL,

    // GET PROCLAMATION RESULTS
    GET_PROCLAMATION_RESULTS,
    GET_PROCLAMATION_RESULTS_SUCCESS,
    GET_PROCLAMATION_RESULTS_FAIL,


    SAVE_FINAL_DECISION, 
    SAVE_FINAL_DECISION_SUCCESS, 
    SAVE_FINAL_DECISION_FAIL,


    GET_FINAL_DECISION, 
    GET_FINAL_DECISION_SUCCESS, 
    GET_FINAL_DECISION_FAIL,


    RUN_ANNUAL_DELIBERATION,
    RUN_ANNUAL_DELIBERATION_SUCCESS,
    RUN_ANNUAL_DELIBERATION_FAIL,


} from "./actionTypes";

export const getSessions = () => ({
    type: GET_SESSIONS,
})

export const getSessionsSuccess = (sessions) => ({
    type: GET_SESSIONS_SUCCESS,
    payload: sessions,
})

export const getSessionsFail = error => ({
    type: GET_SESSIONS_FAIL,
    payload: error,
})

export const addNewSession = (session) => ({
    type: ADD_NEW_SESSION,
    payload: session,
})

export const addSessionSuccess = (session) => ({
    type: ADD_SESSION_SUCCESS,
    payload: session,
})

export const addSessionFail = error => ({
    type: ADD_SESSION_FAIL,
    payload: error,
})

export const updateSession = (session) => ({
    type: UPDATE_SESSION,
    payload: session,
})

export const updateSessionSuccess = (session) => ({
    type: UPDATE_SESSION_SUCCESS,
    payload: session,
})

export const updateSessionFail = error => ({
    type: UPDATE_SESSION_FAIL,
    payload: error,
})

export const deleteSession = (session) => ({
    type: DELETE_SESSION,
    payload: session,
})

export const deleteSessionSuccess = (session) => ({
    type: DELETE_SESSION_SUCCESS,
    payload: session,
})

export const deleteSessionFail = error => ({
    type: DELETE_SESSION_FAIL,
    payload: error,
})

export const resetSessionLastActionSuccess = () => ({
    type: "RESET_LAST_ACTION_SUCCESS"
});

// Actions résultats session
export const getSessionResults = (filters) => ({
    type: GET_SESSION_RESULTS,
    payload: filters,
});

export const getSessionResultsSuccess = (results) => ({
    type: GET_SESSION_RESULTS_SUCCESS,
    payload: results,
});

export const getSessionResultsFail = (error) => ({
    type: GET_SESSION_RESULTS_FAIL,
    payload: error,
});


/*
export const proclamerSession = (payload) => ({
    type: PROCLAMER_SESSION,
    payload,
});

*/

export const proclamerSession = ({ session_uuid, exam_uuid, study_level_id, semester_id }) => ({
    type: PROCLAMER_SESSION,
    payload: { session_uuid, exam_uuid, study_level_id, semester_id },
});


/*
export const proclamerSessionSuccess = () => ({
    type: PROCLAMER_SESSION_SUCCESS,
});

*/

export const proclamerSessionSuccess = (data) => ({
    type: PROCLAMER_SESSION_SUCCESS,
    payload: data,
});

export const proclamerSessionFail = (error) => ({
    type: PROCLAMER_SESSION_FAIL,
    payload: error,
});



// GET PROCLAMATION RESULTS
export const getProclamationResults = (payload) => ({
    type: GET_PROCLAMATION_RESULTS,
    payload,
});
export const getProclamationResultsSuccess = (data) => ({
    type: GET_PROCLAMATION_RESULTS_SUCCESS,
    payload: data,
});
export const getProclamationResultsFail = (error) => ({
    type: GET_PROCLAMATION_RESULTS_FAIL,
    payload: error,
});


// FINAL DECISION
export const saveFinalDecision = (data) => ({
    type: SAVE_FINAL_DECISION,
    payload: data,
});

export const saveFinalDecisionSuccess = (response) => ({
    type: SAVE_FINAL_DECISION_SUCCESS,
    payload: response,
});

export const saveFinalDecisionFail = (error) => ({
    type: SAVE_FINAL_DECISION_FAIL,
    payload: error,
});

export const getFinalDecision = (filters) => ({
    type: GET_FINAL_DECISION,
    payload: filters,
});




export const runAnnualDeliberation = (payload) => ({
    type: RUN_ANNUAL_DELIBERATION,
    payload: payload,
});

export const runAnnualDeliberationSuccess = (response) => ({
    type: RUN_ANNUAL_DELIBERATION_SUCCESS,
    payload: response,
});

export const runAnnualDeliberationFail = (error) => ({
    type: RUN_ANNUAL_DELIBERATION_FAIL,
    payload: error,
});

